export class WipData{
    wipQuantity:number;
    saleOrderId:number;
    saleOrderItemId:number;
    constructor(wipQuantity:number,saleOrderId:number,saleOrderItemId:number){
        this.saleOrderId = saleOrderId;
        this.saleOrderItemId = saleOrderItemId;
        this.wipQuantity = wipQuantity;
    }
}